import { useMemo, useState } from 'react'
import { useMergeFields } from './MergeTags/MergeTag'
import { MergeTagType } from '@web/graphql-types'
import { useHtmlProcessMergeTags } from './MergeTags/useProcessMergeTags'

type HtmlTextProps = {
  html: string
}

const HtmlText = ({ html }: HtmlTextProps) => {
  const hasMergeFields = html.includes('data-merge-tag')
  const [key, setKey] = useState(0)
  const mergeFields = useMergeFields((state) => state.mergeFields)
  const isEditable = useMergeFields((state) => state.isEditing)
  const [postProcessTags, setPostProcessTags] = useState<HTMLElement[]>([])

  const parsedHtml = useMemo(() => {
    setPostProcessTags([])
    if (hasMergeFields && typeof window !== 'undefined') {
      const temp = document.createElement('div')
      temp.innerHTML = html

      const processMergeTags = (temp: HTMLDivElement, mergeFields: Map<string, string>) => {
        Array.from(temp.childNodes).forEach((node) => {
          if (node.nodeType === 1) {
            const element = node as HTMLElement
            const hasMergeTag = element.getAttribute('data-merge-tag')
            const dataValue = element.getAttribute('data-merge-tag-value')
            const fallback = element.getAttribute('data-merge-tag-fallback')
            const type = element.getAttribute('data-merge-tag-type')

            if (hasMergeTag && type !== MergeTagType.Super) {
              const lastFallbackValue = useMergeFields.getState().isEditing ? `{{${dataValue}}}` : ''

              setKey((prev) => prev + 1)
              element.innerHTML = (
                (dataValue && (mergeFields.get(dataValue) || mergeFields.get(dataValue.toLowerCase()))) ||
                fallback ||
                lastFallbackValue
              )?.replace(/\n/g, '<br />')
            }

            if (!isEditable && [MergeTagType.Formula, MergeTagType.Dynamic].includes(type as MergeTagType)) {
              setPostProcessTags((prev) => [...prev, element])
            }

            if (node.hasChildNodes()) {
              processMergeTags(element as HTMLDivElement, mergeFields)
            }
          }
        })
      }
      processMergeTags(temp, mergeFields)
      return Array.from(temp.childNodes)
        .map((node) => {
          const element = node as HTMLElement
          return element.outerHTML
        })
        .join('')
    }

    return html
  }, [html, ...(hasMergeFields ? [mergeFields, isEditable] : [])])

  useHtmlProcessMergeTags(postProcessTags)

  return <div key={key} dangerouslySetInnerHTML={{ __html: parsedHtml }} />
}

export default HtmlText
